export enum ITContractApprovalStatus {
  Approved = "Approved",
  Rejected = "Rejected",
  Undetermined = "Undetermined",
}
